import React from 'react';
import Select from '../Select/Select';

export const COLORS = [
  { value: '#FFFFFF', label: 'ÐÐµÐ»ÑÐ¹' },
  { value: '#000000', label: 'Ð§ÑÑÐ½ÑÐ¹' },
  { value: '#808080', label: 'Ð¡ÐµÑÑÐ¹' },
  { value: '#FF0000', label: 'ÐÑÐ°ÑÐ½ÑÐ¹' },
  { value: '#FFA500', label: 'ÐÑÐ°Ð½Ð¶ÐµÐ²ÑÐ¹' },
  { value: '#FFFF00', label: 'ÐÑÐ»ÑÑÐ¹' },
  { value: '#00FF00', label: 'ÐÐµÐ»ÑÐ½ÑÐ¹' },
  { value: '#00bfff', label: 'ÐÐ¾Ð»ÑÐ±Ð¾Ð¹' },
  { value: '#0000ff', label: 'Ð¡Ð¸Ð½Ð¸Ð¹' },
  { value: '#800080', label: 'Ð¤Ð¸Ð¾Ð»ÐµÑÐ¾Ð²ÑÐ¹' },
  { value: '#964b00', label: 'ÐÐ¾ÑÐ¸ÑÐ½ÐµÐ²ÑÐ¹' },
  { value: '#FFEFDF', label: 'ÐÐµÐ¶ÐµÐ²ÑÐ¹' },
  // ÐÑÑÐµÐ½ÐºÐ¸ Ð¸Ð· Ð¿ÑÐ°Ð¹ÑÐ¾Ð² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÐµÐ¹ â Ð´Ð»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÑÑÐ¾ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐµ ÑÐ²ÐµÑÐ°
  { value: '#0B1F3A', label: 'Ð¢ÑÐ¼Ð½Ð¾-ÑÐ¸Ð½Ð¸Ð¹' },
  { value: '#4A90D9', label: 'ÐÐµÐ±ÐµÑÐ½Ð¾-ÑÐ¸Ð½Ð¸Ð¹' },
  { value: '#A7D3F0', label: 'Ð¡Ð²ÐµÑÐ»Ð¾-Ð³Ð¾Ð»ÑÐ±Ð¾Ð¹' },
  { value: '#C0C0C0', label: 'Ð¡Ð²ÐµÑÐ»Ð¾-ÑÐµÑÑÐ¹' },
  { value: '#4F4F4F', label: 'Ð¢ÑÐ¼Ð½Ð¾-ÑÐµÑÑÐ¹' },
  { value: '#F7F9FA', label: 'Ð¡Ð½ÐµÐ¶Ð½Ð¾-Ð±ÐµÐ»ÑÐ¹' },
  { value: '#F2EFE6', label: 'ÐÐµÐ»ÑÐ¹ Ð¶ÐµÐ¼ÑÑÐ¶Ð½ÑÐ¹' },
  { value: '#D6D6D6', label: 'Ð¡ÐµÑÐµÐ±ÑÐ¸ÑÑÑÐ¹' },
  { value: '#D4AF37', label: 'ÐÐ¾Ð»Ð¾ÑÐ¸ÑÑÑÐ¹' },
  { value: '#C2B280', label: 'ÐÐµÑÐ¾ÑÐ½ÑÐ¹' },
  // Ð¦Ð²ÐµÑÐ°, ÐºÐ¾ÑÐ¾ÑÑÐ¼Ð¸ Ð¼Ð°ÑÐ¸Ð½Ñ ÑÐµÐ°Ð»ÑÐ½Ð¾ Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð² ÑÑÐ¾Ðº Ð¾Ñ Ð·Ð°Ð²Ð¾Ð´Ð¾Ð²: Ð±ÐµÐ· Ð½Ð¸Ñ ÑÐ¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ñ
  // Ð½Ðµ Ðº ÑÐµÐ¼Ñ Ð¿ÑÐ¸Ð²ÑÐ·Ð°ÑÑ, Ð¸ Ð½Ð° Ð²Ð¸ÑÑÐ¸Ð½Ñ ÑÑÐ¾Ð´Ð¸Ñ Ð¾Ð±ÑÐµÐµ ÑÐ¾ÑÐ¾ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð½Ðµ ÑÐ¾Ð³Ð¾ ÑÐ²ÐµÑÐ°
  { value: '#EDEDE8', label: 'ÐÐµÐ»Ð¾-Ð´ÑÐ¼ÑÐ°ÑÑÐ¹' },
  { value: '#F2F2EF', label: 'ÐÐµÐ»ÑÐ¹ Ð¿ÐµÑÐ»Ð°Ð¼ÑÑÑ' },
  { value: '#15171C', label: 'Ð§ÑÑÐ½ÑÐ¹ Ð¿ÐµÑÐ»Ð°Ð¼ÑÑÑ' },
  { value: '#9BA1A6', label: 'ÐÐµÐ¿ÐµÐ»ÑÐ½Ð¾-ÑÐµÑÑÐ¹' },
  { value: '#7E8C7A', label: 'Ð¡ÐµÑÐ¾-Ð·ÐµÐ»ÑÐ½ÑÐ¹' },
  { value: '#6E8CA0', label: 'Ð¡ÐµÑÐ¾-Ð³Ð¾Ð»ÑÐ±Ð¾Ð¹' },
  { value: '#8FBF4F', label: 'Ð¡Ð²ÐµÑÐ»Ð¾-Ð·ÐµÐ»ÑÐ½ÑÐ¹' },
  { value: '#2E4A2E', label: 'Ð¢ÑÐ¼Ð½Ð¾-Ð·ÐµÐ»ÑÐ½ÑÐ¹' },
  { value: '#40E0D0', label: 'ÐÐ¸ÑÑÐ·Ð¾Ð²ÑÐ¹' },
  { value: '#41474D', label: 'ÐÑÐ°ÑÐ¸ÑÐ¾Ð²ÑÐ¹' },
  { value: '#71797E', label: 'Ð¡ÑÐ°Ð»ÑÐ½Ð¾Ð¹' },
  { value: '#1B1B1B', label: 'Ð§ÑÑÐ½Ð¾-Ð¼Ð°ÑÐ¾Ð²ÑÐ¹' },
  { value: '#7B1E24', label: 'ÐÐ¾ÑÐ´Ð¾Ð²ÑÐ¹' },
];

const SelectColor = ({ label, ...props }) => {
  return <Select options={COLORS} label={label || 'Ð¦Ð²ÐµÑ'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectColor;
